//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import 'swiper/dist/css/swiper.css'
import {swiper,swiperSlide} from 'vue-awesome-swiper';
import {mapActions} from 'vuex';
import knowdata from '../../testdata/know';
import force from '../../common/forceLandscape';
  export default {
      name: "topic",
    components:{
      swiper,
      swiperSlide
    },
    data(){
        return{
          swiperOptions:{
            noSwiping:true,
            touchMoveStopPropagation:false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          },
          voiceData:[],
          buildData:[],
          error:0,
          zhengque:0
        }
    },
    methods:{
        ...mapActions(['changeTestStatus']),
      shuffle(){
        this.voiceData.sort(()=>{
          return Math.random()-0.5;
        })
        return Promise.resolve('success');
      },
      checkAnswer(res){
        var swiperindex=this.$refs.swiper.swiper.activeIndex;
        if(!res){
          this.$vux.toast.text('回答错误','center');
          this.error++;
          if(this.error>=5){
            this.changeTestStatus({name:'know',value:{zq:this.zhengque,cw:this.error,tested:true}}).then(_=>{
              this.$router.replace({name:'complete',query:{zq:this.zhengque,cw:this.error}});
            });
          }
        }else{
          this.zhengque++;
          this.$vux.toast.text('回答正确','center');
        }
        if(swiperindex>=7){
          this.changeTestStatus({name:'know',value:{zq:this.zhengque,cw:this.error,tested:true}}).then(_=>{
            this.$router.replace({name:'complete',query:{zq:this.zhengque,cw:this.error}});
          });
        }
        this.$refs.swiper.swiper.slideTo(swiperindex+1);
      },
      play(spot){

        this.$refs.audio.src=spot;
      }
    },
    created() {
      var routename=this.$route.name;
      var tixing=this.$store.state.tixing['lv'+this.$store.state.testLevel];
      var index=tixing.indexOf(routename);
      var title=`Test ${index+1} ${this.$store.state.title['lv'+this.$store.state.testLevel][index]}`;
      document.title=title;
      this.voiceData=knowdata['lv'+this.$store.state.testLevel];
      this.shuffle().then(_=>{  //打乱排列
        if(this.voiceData[0].text){
          for(let i=0;i<8;i++){
            var data=this.voiceData.slice(i*3,i*3+3);
            var answer=data[Math.floor(Math.random()*data.length)];
            this.buildData.push({data:data,answer:answer});
          }
        }
        if(this.voiceData[0].pic){
          for (let i=0;i<10;i++){
            var data=this.voiceData[i];
            var arr=[];
            for (let j=97;j<=122;j++){
              var s=String.fromCharCode(j);
              if(s!=data.answer){
                arr.push(String.fromCharCode(j));
              }
            }
            arr.sort(()=>{
              return Math.random()-0.5;
            })
            var choose=arr.slice(0,2);
            choose.push(data.answer);
            choose.sort(()=>{
              return Math.random()-0.5
            });
            console.log(choose);
            this.buildData.push({
              ...data,
              choose:choose
            });
          }
        }

      });
      console.log(knowdata);
    },
    mounted() {
        force();
    }
  }



// WEBPACK FOOTER //
// ./src/components/topic/topic.vue